
    import React from 'react';
    import SegmentFormPageContainer from './SegmentFormPageContainer';
    
    export class SegmentFormPage extends React.Component{
        render(){
            return (
                <SegmentFormPageContainer {...this.props}/>
            )
        }
    }
    